import { Component, OnInit,Inject } from '@angular/core';
import { DataApiService } from 'src/app/Services/data-api.service';
import {MatDialog, MatDialogRef,MatDialogConfig, MAT_DIALOG_DATA} from '@angular/material';
import { AlertComponent } from '../alert/alert.component';

export interface DialogData {
  mensaje: string;
  
}

@Component({
  selector: 'app-modificar-precio',
  templateUrl: './modificar-precio.component.html',
  styleUrls: ['./modificar-precio.component.scss']
})

export class ModificarPrecioComponent implements OnInit { 
   
  mensaje="Los precios han sido modificados con éxito";

 
  constructor(
    private dataApi:DataApiService,
    private dialog: MatDialog
  ) { }

  public form = {
    precioRecojoAEntrega: null,
    precioBase: null,
    precioOficinaARecojo: null,
    precioCargoNocturno:null,
    horaCargoNocturno:"19:00:00",
    horaCargoNocturnoFinal:null,
    altaDemanda:null,
  }
  
  public error = null;

  ngOnInit() {
    this.getPrices();
  }
  getPrices(){
    this.dataApi.getPrices().subscribe((data)=>{  
     
      this.form.precioRecojoAEntrega =  data["precioRecorrido"];
      this.form.precioBase = data["precioBase"];
      this.form.precioOficinaARecojo = data["precioARecojo"];
      this.form.precioCargoNocturno = data["precioCargoNocturno"];
      this.form.horaCargoNocturno= data["horaCargoNocturno"];
      this.form.horaCargoNocturnoFinal= data["horaCargoNocturnoFinal"];
      this.form.altaDemanda = data["altaDemanda"];

    })
  }
  
  onSubmit():void{
    //console.log(this.form)
    this.dataApi.updatePrices(this.form).subscribe(
      data =>this.handleResponse(data),
      error =>this.handleError(error)
    )
  } 
  
  handleResponse(data){
    console.log(data);
    this.dialog.closeAll();       
    const dialogRef = this.dialog.open(AlertComponent,{
      width:"40%",
      data:{mensaje:this.mensaje},
      disableClose: false,
      autoFocus:true
    }); 

    dialogRef.afterClosed().subscribe(result => {      
      this.mensaje = result;
    });
  }

  handleError(error){
    this.error = error.error.error;
  }

}
